export default "__VITE_ASSET__994b89ec__"